import { useCallback } from 'react';
import { useTheme } from 'styled-components';
import debounce from 'lodash.debounce';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import useForm from '../../../../lib/hooks/useForm';
import { api } from '../../../../lib/api';

const mutationFn = values => {
  const { uuid, name, color, welcomeMessage } = values;

  return api.patch(`/api/client_admin/campaigns/${uuid}`, {
    campaign: {
      name,
      color,
      welcome_message: welcomeMessage,
    },
  });
};

export const useBannerForm = ({ name, welcomeMessage, color, id }) => {
  const { colors } = useTheme();
  const queryClient = useQueryClient();
  const { mutate } = useMutation(mutationFn);

  const initialValues = {
    uuid: id,
    name: name || '',
    welcomeMessage: welcomeMessage || '',
    color: color || colors.primary[100],
  };

  const form = useForm({
    initialValues,
    enableReinitialize: true,
  });

  const makeOnSuccess = field => ({ data }) => {
    queryClient.setQueryData(
      ['campaignData', data.campaign.uuid],
      prevData => ({
        campaign: { ...prevData.campaign, ...data.campaign[field] },
      }),
    );
  };

  const handleSubmit = (field, values) => mutate(values, makeOnSuccess(field));

  const debouncedSubmit = useCallback(debounce(handleSubmit, 2000), []);

  const handleChange = (field, value) => {
    form.setFieldValue(field, value);
    debouncedSubmit(field, { ...form.values, [field]: value });
  };

  return { ...form, handleChange, handleSubmit };
};
